// @ts-strict-ignore
import clsx from 'clsx'
import React, { useRef, useState } from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { Button } from '@/shared/ui'

import { DescriptionScript } from './description-script'

import cl from './styles.module.scss'

type DescriptionTabProps = {
	description: string
	productKod?: string
}

export const DescriptionTab = ({ description: description, productKod }: DescriptionTabProps): JSX.Element => {
	const ref = useRef<HTMLDivElement>(null)
	const [isCollapsed, setIsCollapsed] = useState(true)

	const classes = clsx(cl.root, {
		[cl.root__isCollapsed]: isCollapsed
	})
	return (
		<section>
			<div className={classes} ref={ref} dangerouslySetInnerHTML={createMarkup(description)} />
			<DescriptionScript productKod={productKod} decriptionNode={ref?.current} />
			<Button theme="link" onClick={() => setIsCollapsed(prev => !prev)}>
				{isCollapsed ? 'Читать полностью' : 'Свернуть'}
			</Button>
		</section>
	)
}
